document.addEventListener("DOMContentLoaded", function () {
	let artists: Array<HTMLElement> = [...document.querySelectorAll<HTMLElement>("[data-cabinet-item]")];
  for (const artist of artists) {
		if (window.screen.width > 821) {
			artist.addEventListener("mouseenter", function () {
				var itemSlug = artist.getAttribute("data-cabinet-item");
				if (artists != null) {
					let currentItem = document.querySelector('[data-cabinet-item="' + itemSlug + '"]');
					if (currentItem != null) {
						if (!currentItem.classList.contains("active")) {
							artists.forEach((el) => {
								el.classList.remove("active");
							});
							currentItem.classList.add("active");
						}
						return false;
					}
				}
			});
		}
  }
});